import { FormEvent, MouseEvent } from 'react';
import { Action, ActionStatus, IExpertSystemRecipientDonor } from "./models";
import { Alert, Button, Col, ControlLabel, DropdownButton, FormControl, FormGroup, MenuItem, Panel } from "react-bootstrap";
import SingleEpletMmRisk from "../swap-management/single-eplet-mm-risk";
import MaskedInput from 'react-maskedinput';

interface IProps {
    index: number,
    order: IExpertSystemRecipientDonor,
    recipientAbo: string,
    centerId: number,
    onAction: (action: Action, orderId: number) => void,
    onProcessAction: (orderId: number, action: Action, cancel: boolean) => void,
    onDismissAlert: (orderId: number, action: Action) => void,
    onSurgeryDateChange: (orderId: number, surgeryDate: string) => void
}

const RecipientDonorsModalRow = (props: IProps) => {
    const handleAction = (eventKey: any) => {
        let action = parseInt(eventKey);
        props.onAction(action, props.order.id);
    };

    const handleProcessAction = (e: MouseEvent<Button & HTMLButtonElement>) => {
        let id = e.currentTarget.id;
        let name = e.currentTarget.name;
        let cancel = id.indexOf('cancel') >= 0;

        if (name == 'standard-voucher') {
            props.onProcessAction(props.order.id, Action.StartStandardVoucher, cancel);
        }

        if (name == 'kpd-pair') {
            props.onProcessAction(props.order.id, Action.StartKpdPair, cancel);
        }

        if (name == 'internal-direct') {
            props.onProcessAction(props.order.id, Action.StartInternalDirect, cancel);
        }

        if (name == 'withdraw-donor') {
            props.onProcessAction(props.order.id, Action.WithdrawDonor, cancel);
        }
    };

    const handleDismissAlert = (e: any) => {
        if (e.currentTarget.id == 'dismiss-standard-voucher') {
            props.onDismissAlert(props.order.id, Action.StartStandardVoucher);
        }

        if (e.currentTarget.id == 'dismiss-kpd-pair') {
            props.onDismissAlert(props.order.id, Action.StartKpdPair);
        }

        if (e.currentTarget.id == 'dismiss-internal-direct') {
            props.onDismissAlert(props.order.id, Action.StartInternalDirect);
        }

        if (e.currentTarget.id == 'dismiss-withdraw-donor') {
            props.onDismissAlert(props.order.id, Action.WithdrawDonor);
        }
    }

    const handleSurgeryDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        props.onSurgeryDateChange(props.order.id, e.currentTarget.value);
    }

    const getDonorCenter = (order: IExpertSystemRecipientDonor) => {
        if (order.donorRdnCenterId > 0) {
            return <>{order.donorCenterAlias} (<span style={{ color: 'red' }}>{order.donorRdnCenterAlias}</span>)</>;
        }

        return <>{order.donorCenterAlias}</>;
    };

    // const renderAlert = (order:IExpertSystemRecipientDonor, action:Action) => {
    //     return (
    //         <tr>
    //             <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
    //                 <Alert id='dismiss-standard-voucher' bsStyle='success' onDismiss={handleDismissAlert}>
    //                     This pair (donor: {order.donorAlias} / recipient: {order.recipientAlias}) has been converted to a standard voucher pair.<br />
    //                     To enter the remaining data on the profile, <a href={`center/${props.centerId}/recipient/${order.recipientId}/profile/general`} target='_blank'>click here</a>.
    //                 </Alert>
    //             </td>
    //         </tr>
    //     );
    // }

    let { index, order } = props;

    let disableActions =
        order.standardVoucher > ActionStatus.Pending
        || order.kpdPair > ActionStatus.Pending
        || order.internalDirect > ActionStatus.Pending
        || order.withdrawDonor > ActionStatus.Pending
        ;

    return (
        <>
            <tr>
                <td>{index + 1}</td>
                <td>{getDonorCenter(order)}</td>
                <td>{order.donorAlias}</td>
                <td>{order.donorAbo}</td>
                <td>{props.recipientAbo}</td>
                <td><SingleEpletMmRisk data={order.singleEpletMmRisk} isAdmin={false} centerId={props.centerId} /></td>
                <td>{order.status}</td>
                <td style={{ textAlign: 'right' }}>
                    <DropdownButton id={'es-order-actions-' + order.id} title='Actions' bsStyle='primary' bsSize='sm' disabled={disableActions}>
                        <MenuItem eventKey={Action.Evaluate} onSelect={handleAction}>Evaluate</MenuItem>
                        <MenuItem divider></MenuItem>
                        {/* <MenuItem eventKey={Action.StartStandardVoucher} onSelect={handleAction}>Start Standard Voucher</MenuItem>
                        <MenuItem eventKey={Action.StartKpdPair} onSelect={handleAction}>Start KPD Pair</MenuItem>
                        <MenuItem eventKey={Action.StartInternalDirect} onSelect={handleAction}>Start Internal Direct</MenuItem>
                        <MenuItem divider></MenuItem>
                        <MenuItem eventKey={Action.PotentialDonors} onSelect={handleAction}>Potential Donors</MenuItem> */}
                        <MenuItem eventKey={Action.WithdrawDonor} onSelect={handleAction}>Withdraw Donor</MenuItem>
                    </DropdownButton>
                </td>
            </tr>

            {order.standardVoucher == ActionStatus.Confirm && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Panel bsStyle='warning' style={{ marginBottom: 0 }}>
                            <Panel.Heading style={{ textAlign: 'left' }}>Convert to Standard Voucher Pair?</Panel.Heading>
                            <Panel.Body>
                                <div>Are you sure that you want to convert donor <strong>{order.donorAlias}</strong> and recipient <strong>{order.recipientAlias}</strong> to a standard voucher pair?</div>
                            </Panel.Body>
                            <Panel.Footer style={{ backgroundColor: '#fcf8e3', paddingTop: 5, paddingBottom: 5 }}>
                                <Button id='process-standard-voucher' name='standard-voucher' bsStyle='primary' bsSize='sm' style={{ marginRight: 5 }} onClick={handleProcessAction}>Yes, Convert</Button>
                                <Button id='cancel-standard-voucher' name='standard-voucher' bsSize='sm' onClick={handleProcessAction}>No, Cancel</Button>
                            </Panel.Footer>
                        </Panel>
                    </td>
                </tr>
            )}

            {order.standardVoucher == ActionStatus.Completed && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Alert id='dismiss-standard-voucher' bsStyle='success' style={{ marginBottom: 0 }} onDismiss={handleDismissAlert}>
                            This pair (donor: {order.donorAlias} / recipient: {order.recipientAlias}) has been converted to a standard voucher pair.<br />
                            To enter the remaining data on the profile, <a href={`center/${props.centerId}/recipient/${order.recipientId}/profile/general`} target='_blank'>click here</a>.
                        </Alert>
                    </td>
                </tr>
            )}

            {order.kpdPair == ActionStatus.Confirm && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Panel bsStyle='warning' style={{ marginBottom: 0 }}>
                            <Panel.Heading style={{ textAlign: 'left' }}>Convert to Compatible KPD Pair?</Panel.Heading>
                            <Panel.Body>
                                <div>Are you sure that you want to convert donor <strong>{order.donorAlias}</strong> and recipient <strong>{order.recipientAlias}</strong> to a compatible KPD pair?</div>
                            </Panel.Body>
                            <Panel.Footer style={{ backgroundColor: '#fcf8e3', paddingTop: 5, paddingBottom: 5 }}>
                                <Button id='process-kpd-pair' name='kpd-pair' bsStyle='primary' bsSize='sm' style={{ marginRight: 5 }} onClick={handleProcessAction}>Yes, Convert</Button>
                                <Button id='cancel-kpd-pair' name='kpd-pair' bsSize='sm' onClick={handleProcessAction}>No, Cancel</Button>
                            </Panel.Footer>
                        </Panel>
                    </td>
                </tr>
            )}

            {order.kpdPair == ActionStatus.Completed && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Alert id='dismiss-kpd-pair' bsStyle='success' style={{ marginBottom: 0 }} onDismiss={handleDismissAlert}>
                            This pair (donor: {order.donorAlias} / recipient: {order.recipientAlias}) has been converted to a compatible pair.<br />
                            To enter the remaining data on the profile, <a href={`center/${props.centerId}/recipient/${order.recipientId}/profile/general`} target='_blank'>click here</a>.
                        </Alert>
                    </td>
                </tr>
            )}

            {order.internalDirect == ActionStatus.Confirm && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Panel bsStyle='warning' style={{ marginBottom: 0 }}>
                            <Panel.Heading style={{ textAlign: 'left' }}>Convert to KFL Internal Direct?</Panel.Heading>
                            <Panel.Body>
                                {order.validInternalDirectSurgeryDate == false && (
                                    <Alert bsStyle='danger' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>Please enter a valid surgery date below...</Alert>
                                )}

                                <div style={{ marginBottom: 20 }}>Please enter the surgery date for donor {order.donorAlias} to donate to recipient {order.recipientAlias}</div>
                                <FormGroup style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 0 }} validationState={order.validInternalDirectSurgeryDate == false ? 'error' : null}>
                                    <ControlLabel style={{ marginBottom: 0, marginRight: 5 }}>Surgery Date:</ControlLabel>
                                    <MaskedInput
                                        className='form-control'
                                        style={{ width: 'initial' }}
                                        mask='11/11/1111'
                                        placeholder='mm/dd/yyyy'
                                        value={order.internalDirectSurgeryDate}
                                        onChange={handleSurgeryDateChange}
                                    />
                                </FormGroup>
                            </Panel.Body>
                            <Panel.Footer style={{ backgroundColor: '#fcf8e3', paddingTop: 5, paddingBottom: 5 }}>
                                <Button id='process-internal-direct' name='internal-direct' bsStyle='primary' bsSize='sm' style={{ marginRight: 5 }} onClick={handleProcessAction}>Yes, Confirm</Button>
                                <Button id='cancel-internal-direct' name='internal-direct' bsSize='sm' onClick={handleProcessAction}>No, Cancel</Button>
                            </Panel.Footer>
                        </Panel>
                    </td>
                </tr>
            )}

            {order.internalDirect == ActionStatus.Completed && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Alert id='dismiss-internal-direct' bsStyle='success' style={{ marginBottom: 0 }} onDismiss={handleDismissAlert}>
                            This pair (donor: {order.donorAlias} / recipient: {order.recipientAlias}) has been converted to an internal direct pair.<br />
                            To enter the remaining data on the profile, <a href={`center/${props.centerId}/recipient/${order.recipientId}/profile/general`} target='_blank'>click here</a>.
                        </Alert>
                    </td>
                </tr>
            )}

            {order.withdrawDonor == ActionStatus.Confirm && (
                <tr>
                    <td colSpan={7} style={{ paddingLeft: 0, paddingRight: 0 }}>
                        <Panel bsStyle='warning' style={{ marginBottom: 0 }}>
                            <Panel.Heading style={{ textAlign: 'left' }}>Withdraw Donor?</Panel.Heading>
                            <Panel.Body>
                                <div>Are you sure that you want to withdraw donor <strong>{order.donorAlias}</strong>?</div>
                            </Panel.Body>
                            <Panel.Footer style={{ backgroundColor: '#fcf8e3', paddingTop: 5, paddingBottom: 5 }}>
                                <Button id='process-withdraw-donor' name='withdraw-donor' bsStyle='primary' bsSize='sm' style={{ marginRight: 5 }} onClick={handleProcessAction}>Yes, Withdraw</Button>
                                <Button id='cancel-withdraw-donor' name='withdraw-donor' bsSize='sm' onClick={handleProcessAction}>No, Cancel</Button>
                            </Panel.Footer>
                        </Panel>
                    </td>
                </tr>
            )}
        </>
    );
}

export default RecipientDonorsModalRow;